export default __webpack_public_path__ + "static/media/strong 3 hiit.47e5fd4e.png";